import classNames from 'classnames';
import { Icon } from 'design-system/client';
import { useCallback, useMemo } from 'react';
import { ShareState, type ShareStateType } from '../hooks/useShareImage/useShareImage';
import styles from './InstagramShareButton.module.css';
function InstagramShareButton({
  onClick,
  state,
  utmParams,
  shareUrl
}: {
  onClick: (url: string) => void;
  state: ShareStateType;
  textCopied: boolean;
  utmParams?: Record<'utmCampaign' | 'utmMedium', string | string[]>;
  shareUrl: string;
}) {
  const searchParams = useMemo(() => new URLSearchParams(Object.entries({
    utm_campaign: utmParams?.utmCampaign,
    utm_medium: utmParams?.utmMedium,
    utm_source: 'Instagram'
  }).filter(([, value]) => value !== undefined).map(([key, value_0]) => [key, value_0 as string])), [utmParams?.utmCampaign, utmParams?.utmMedium]);
  const handleClick = useCallback(() => {
    onClick(`${shareUrl}?${searchParams.toString()}`);
  }, [onClick, searchParams, shareUrl]);
  return <button className={classNames(styles.socialSharingButton, styles.link, styles.linkButton, styles.copyInstagramBackground, {
    [styles.success!]: state === ShareState.Success,
    [styles.error!]: state === ShareState.Error
  })} onClick={handleClick} aria-live="polite"
  // TODO: labels for the button need to be created for the different states it can have
  aria-label="Instagram">
      <Icon name="instagram" color="fg-light-primary" size="400" className={styles.copyLink} />
      <Icon name="check" color="fg-light-primary" size="400" className={styles.successFeedback} />
      <Icon name="x" color="fg-light-primary" size="400" className={styles.errorFeedback} />
    </button>;
}
export default InstagramShareButton;